<div class="month-title">
  <p class="font-sans text-h600 text-eggplant-100/[0.25] pb-[30px]">{{monthWithBenefits.dateName}}</p>
</div>
<div class="mb-48 bg-white rounded-2xl">
  <ng-container *ngFor="let benefit of monthWithBenefits.benefits; let i = index">
      <div class="w-full relative flex">
          <div class="inline-block w-full px-16 md:px-[40px]">
            <div class="py-16 md:py-[28px]" [ngClass]="{ 'border-b border-b-eggplant-100/[0.1]': i + 1 < monthWithBenefits.benefits.length }">
              <div class="flex">
                <div class="w-full">
                  <p *ngIf="!benefit.paymentStatus"
                  class="font-sans text-s md:text-m text-center uppercase w-fit px-6 rounded-xl pt-2 text-white bg-eggplant-100/[0.25]">Estimado</p>
                  <div *ngIf="benefit.paymentStatus" class="flex gap-12 items-center">
                    <p
                    class="font-sans text-s md:text-m text-center uppercase w-fit px-6 rounded-xl pt-2 text-white"
                    [ngClass]="{
                      'bg-active': benefit.paymentStatus === 'Programado',
                      'bg-eggplant-70': benefit.paymentStatus === 'Aplazado',
                      'bg-cream-100 !text-eggplant-80': benefit.paymentStatus === 'Pagado',
                      'bg-orange-100': benefit.paymentStatus === 'Cancelado',
                      'bg-eggplant-100/[0.25]': (benefit.paymentStatus !== 'Programado' && benefit.paymentStatus !== 'Aplazado' && benefit.paymentStatus !== 'Cancelado' && benefit.paymentStatus !== 'Pagado')
                    }"> {{ benefit.paymentStatus }} </p>
                    <p class="text-l font-sans text-eggplant-80 uppercase">{{ benefit.date[2] }}/{{ benefit.date[1] }}/{{ benefit.date[0] }}</p>
                  </div>

                  <p *ngIf="!benefit.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6">{{'PAYMENT_CALENDAR.BENEFITS_COMMON_TYPE' | translate}}</p>
                  <p *ngIf="benefit.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6">{{ benefit.paymentTitle }}</p>
                  <p class="font-sans text-s md:text-l text-eggplant-100/[0.55]">{{benefit.projectName}}</p>
                </div>
                <div class="min-w-[80px] md:min-w-[146px] pl-6 py-6 md:py-0 flex items-center justify-center">
                  <p *ngIf="benefit.amount > 0" class="text-right font-sans text-l md:text-xl text-eggplant-80">{{benefit.amount | currency: 'EUR': 'symbol': '1.2-2'}}</p>
                  <p *ngIf="benefit.amount === 0" class="text-right font-sans text-s md:text-l text-eggplant-100/[0.55]">Por determinar</p>
                </div>
              </div>
              <div *ngIf="benefit.paymentDescription"><p class="font-sans text-m md:text-l text-eggplant-80 pt-16">{{ benefit.paymentDescription }}</p></div>
            </div>
          </div>
      </div>
  </ng-container>
</div>
